<template lang="html">
  <div>
    <div class="row p-1">
      <div class="col-12  d-flex align-items-center justify-content-between">
        <div class="col-auto">
          <div class="heading pt-0 mb-0">Réponse générée {{ answer.updated_on | from_now }}</div>
          <div class="text-muted small">Le {{ human_datetime(answer.updated_on) }}</div>
        </div>
        <div class="col-auto" v-if="has_game_set">
          <a href="#" @click.prevent="!is_best_answer && vote_for_best_answer()">
            <i :class="['icon-18', is_best_answer ? 'bi-heart-fill text-danger' : 'bi-heart']"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="mb-2 text-alternate">
      <textarea style=" resize: both;" class="form-control " rows="8" disabled="disabled" :ref="'answer_' + answer.uid">{{ answer.answer_text }}
      </textarea>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <a v-if="answer.score_human_global_note == null" href="#" class="d-flex align-items-center"
         data-bs-toggle="collapse"
         :data-bs-target="'#collapseEvaluate-' + answer.uid"
         aria-expanded="true"
         :aria-controls="'collapseEvaluate-' + answer.uid">
        <i class="icon-18 bi-sliders first me-2"></i>

        Évaluer
      </a>
      <a v-else="v-else" href="#" class="d-flex align-items-center text-success" data-bs-toggle="collapse"
         :data-bs-target="'#collapseEvaluate-' + answer.uid"
         aria-expanded="true"
         :aria-controls="'collapseEvaluate-' + answer.uid">
        <i class="icon-18 bi-sliders first me-2"></i>
        Déjà évaluée
      </a>
      <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
        <button type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="collapse"
                :data-bs-target="'#collapseImprove-' + answer.uid"
                aria-expanded="true"
                :aria-controls="'collapseImprove-' + answer.uid" v-if="can_improve_answer">Améliorer
        </button>
        <div class="btn-group" role="group">
          <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-outline-primary btn-sm dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
          >
            Copier
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
            <a class="dropdown-item" href="#" @click="copy_to_clipboard(answer.uid)">Vers presse-papier</a>
            <a class="dropdown-item" href="#" @click="copy_to_answer(answer.uid)">Vers réponse</a>
          </div>
        </div>
      </div>
    </div>
    <div class="collapse" :id="'collapseImprove-' + answer.uid">
      <div class="row">
        <div class="col-12">
          <textarea style=" resize: both;" v-model="improve_text" class="form-control mb-3 mt-3" rows="5"
                    placeholder="Vous pouvez ici affiner votre demande à l'Assistant: ajouter une information, demander de corriger un élément de la réponse précédente, etc"></textarea>
          <div class="d-flex align-items-center justify-content-end">
            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

              <button type="button" class="btn btn-sm btn-primary" @click="improve_answer">Régénérer la réponse</button>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="collapse" :id="'collapseEvaluate-' + answer.uid">
      <div class="row">
        <div class="col-12">
          <div class="mb-6">
            <label for="globalNote" class="form-label">
              Note globale ?&nbsp;&nbsp;
            </label>

            <span class="tag is-rounded is-dark"
                  :class="{'is-danger': answer.score_human_global_note == null, 'is-warning': answer.score_human_global_note < 4, 'is-success': answer.score_human_global_note > 7}">
                  {{ answer.score_human_global_note|default("inconnu") }}
              </span>

            <input type="range"
                   min="1"
                   max="10"
                   value=""
                   step="1"
                   style="width:100%;"
                   v-model="answer.score_human_global_note">
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <label for="scoreRespect" class="form-label">
              Respect de la ligne éditoriale ?&nbsp;&nbsp;
            </label>

            <span class="tag is-rounded is-dark"
                  :class="{'is-danger': answer.score_human_style_respect == null, 'is-warning': answer.score_human_style_respect < 4, 'is-success': answer.score_human_style_respect > 7}">
                    {{ answer.score_human_style_respect|default("inconnu") }}
                </span>

            <input type="range"
                   min="1"
                   max="10"
                   value=""
                   step="1"
                   style="width:100%;"
                   v-model="answer.score_human_style_respect">
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label for="humanDiversity" class="form-label">
                Diversité entre les réponses ?&nbsp;&nbsp;
              </label>
              <span class="tag is-rounded is-dark"
                    :class="{'is-danger': answer.score_human_answers_diversity == null, 'is-warning': answer.score_human_answers_diversity < 4, 'is-success': answer.score_human_answers_diversity > 7}">
                  {{ answer.score_human_answers_diversity|default("inconnu") }}
              </span>
              <input type="range"
                     min="1"
                     max="10"
                     value=""
                     step="1"
                     style="width:100%;"
                     v-model="answer.score_human_answers_diversity">
            </div>
            <div class="mb-3">
              <label for="scoreContext" class="form-label">
                Réponse aux éléments cités dans l'avis ?&nbsp;&nbsp;
              </label>
              <span class="tag is-rounded is-dark"
                    :class="{'is-danger': answer.score_human_review_context == null, 'is-warning': answer.score_human_review_context < 4, 'is-success': answer.score_human_review_context > 7}">
                  {{ answer.score_human_review_context|default("inconnu") }}</span>
              <input type="range"
                     min="1"
                     max="10"
                     value=""
                     step="1"
                     style="width:100%;"
                     v-model="answer.score_human_review_context">
            </div>
            <div class="mb-3">
              <label for="scoreMarketing" class="form-label">
                Mise en valeur de l'établissement et de ses points forts ? &nbsp;&nbsp;
              </label>
              <span>&nbsp;</span><span class="tag is-rounded is-dark"
                                       :class="{'is-danger': answer.score_human_marketing == null, 'is-warning': answer.score_human_marketing < 4, 'is-success': answer.score_human_marketing > 7}">{{
                answer.score_human_marketing|default("inconnu")
              }}
              </span>
              <input type="range"
                     min="1"
                     max="10"
                     value=""
                     step="1"
                     style="width:100%;"
                     v-model="answer.score_human_marketing">
            </div>
            <div class="mb-3">
              <label for="scoreHallucinations" class="form-label">
                Absence d'argument inventé ?&nbsp;&nbsp;
              </label>
              <span class="tag is-rounded is-dark"
                    :class="{'is-danger': answer.score_human_no_hallucinations == null, 'is-warning': answer.score_human_no_hallucinations < 4, 'is-success': answer.score_human_no_hallucinations > 7}">
                  {{ answer.score_human_no_hallucinations|default("inconnu") }}
              </span>
              <input type="range"
                     min="1"
                     max="10"
                     value=""
                     step="1"
                     style="width:100%;"
                     v-model="answer.score_human_no_hallucinations">

            </div>
          </div>
          <div class="col-12">
            <textarea style=" resize: both;" class="form-control mb-3 mt-3" rows="5" placeholder="Remarques"
                      v-model="answer.score_human_comments"></textarea>
            <div class="d-flex align-items-center justify-content-end">
              <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                <button type="button" class="btn btn-sm btn-outline-primary" :class="{'is-loading': saving}"
                        @click="reset_and_save_scores" :disabled="!can_save_scores">Effacer mon évaluation
                </button>
                <button type="button" class="btn btn-sm btn-primary" :class="{'is-loading': saving}"
                        @click="save_scores" :disabled="!can_save_scores">Enregistrer l'évaluation
                </button>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="block">
        <div class="notification is-danger" v-if="error"><span>{{ error }}</span></div>
      </div>
      <div class="block" v-if="show_regenerating_modal">
        <span v-if="show_regenerating_modal">En cours de regénération...</span>
      </div>
      <div class="block notification is-danger" v-if="regeneration_error">
        <span>Il y a eu une erreur durant la génération: {{ regeneration_error_message }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import settings from '@/settings.coffee';
import LOGOSANSWER_RESET_SCORES from '@/gql/mutations/logosanswerResetScores.graphql';
import LOGOSANSWER_SET_HUMAN_SCORES from '@/gql/mutations/logosanswerSetHumanScores.graphql';
import UPDATE_GAME from '@/gql/mutations/updateGame.graphql';
import IMPROVE_ANSWER from '@/gql/mutations/updateAnswer.graphql';
import REVIEW_ENSURE_ALL_GAMES from '@/gql/mutations/reviewEnsureAllGames.graphql';
import REVIEW_GENERATE_LOGOS_ANSWER from '@/gql/mutations/reviewGenerateLogosAnswer.graphql';
import {gqlMutation} from '@/gqlClient.js';
import moment from "moment";
import utils from '@/utils.js';
import Vue from 'vue';

moment.locale("fr");

export default {
  name: "LogosSingleAnswer",
  props: {
    answer: Object,
    has_game_set: Boolean,
    game_set: Array,
    can_improve_answer: Boolean
  },
  data() {
    return {
      generating: false,
      show_regenerating_modal: false,
      show_scores: false,
      error: null,
      saving: false,
      show_improve_modal: false,
      improve_text: "",
      regeneration_error: false,
      regeneration_error_message: null
    };
  },
  computed: {
    can_save_scores() {
      const a = this.answer;
      return a.score_human_global_note != null &&
          a.score_human_style_respect != null &&
          a.score_human_answers_diversity != null &&
          a.score_human_review_context != null &&
          a.score_human_marketing != null &&
          a.score_human_no_hallucinations != null;
    },
    is_best_answer() {
      for (let i = 0; i < this.game_set.length; i++) {
        const game = this.game_set[i];
        if (game.best_answer != null && this.answer.uid === game.best_answer.uid) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    async reset_and_save_scores() {
      const self = this;
      self.answer.score_human_global_note = null;
      self.answer.score_human_style_respect = null;
      self.answer.score_human_answers_diversity = null;
      self.answer.score_human_review_context = null;
      self.answer.score_human_marketing = null;
      self.answer.score_human_no_hallucinations = null;
      self.answer.score_human_comments = null;
      self.saving = true;
      await gqlMutation(LOGOSANSWER_RESET_SCORES, {uid: self.answer.uid});
      setTimeout(function () {
        self.saving = false;
        self.show_scores = false;
        self.$emit("scores-saved");
      }, 250);
    },
    async save_scores() {
      const self = this;
      self.saving = true;
      await gqlMutation(LOGOSANSWER_SET_HUMAN_SCORES, {
        uid: self.answer.uid,
        global: parseInt(self.answer.score_human_global_note),
        style: parseInt(self.answer.score_human_style_respect),
        diversity: parseInt(self.answer.score_human_answers_diversity),
        context: parseInt(self.answer.score_human_review_context),
        marketing: parseInt(self.answer.score_human_marketing),
        hallucinations: parseInt(self.answer.score_human_no_hallucinations),
        comments: self.answer.score_human_comments
          ? btoa(encodeURIComponent(self.answer.score_human_comments).replace(/%([0-9A-F]{2})/gi, (_, p1) => String.fromCharCode(parseInt(p1, 16))))
          : undefined,
      });
      setTimeout(function () {
        self.saving = false;
        self.show_scores = false;
        self.$emit("scores-saved");
      }, 250);
    },
    toggle_show_scores() {
      this.show_scores = !this.show_scores;
    },
    async generate_answer() {
      const self = this;
      self.generating = true;
      const response = await gqlMutation(REVIEW_GENERATE_LOGOS_ANSWER, {uid: self.$store.state.selected_review_uid});
      if (response.ok) {
        if (response.body.data.review_generate_logos_answer.ok) {
          self.error = null;
        } else {
          self.error = response.body.data.review_generate_logos_answer.msg;
        }
      } else {
        self.error = response.body.data;
      }
      self.generating = false;
    },
    human_datetime(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    copy_to_clipboard(answer_uid) {
      const el = this.$refs["answer_" + answer_uid];
      const text = el.value;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    async copy_to_answer(answer_uid) {
      this.error = null;
      const el = this.$refs["answer_" + answer_uid];
      let content = el.value;
      let target_id = "review_state_answer_writing_textarea_answer_fr_" + this.$store.state.selected_review_uid;
      let target_el = document.getElementById(target_id);
      if (!target_el) {
        target_el = document.getElementById('review_state_answer_text_validation_textarea_answer_fr_' + this.$store.state.selected_review_uid);
      }
      if (!target_el) {
        this.error = "Nous n'avons pas trouvé le champ pour copier la réponse. Réssayez lorsque vous êtes à l'étape de rédaction de la réponse (ou de validation pour les groupes).";
      } else {
        content = el.value;
        if (target_el.value === "" || typeof target_el.value === "undefined") {
          this.$root.state_set_answer_content(content);
          this.error = null;
        } else {
          this.error = "Réponse déjà saisie, veuillez l'effacer avant de copier/coller la réponse Logos.";
        }
      }
      if (this.error === null) {
        for (let i = 0; i < this.game_set.length; i++) {
          const game = this.game_set[i];
          const uid = this.answer.uid.toString();
          if ((game.answer1.uid === answer_uid) || (game.answer2.uid === answer_uid)) {
            await gqlMutation(UPDATE_GAME, {id: game.uid, copied_answer_id: answer_uid, copy_button_pushed: true});
          }
        }
      }
    },
    set_height() {
      const self = this;
      utils.debounce(function () {
        self.height = (window.innerHeight - 65) + "px";
      }, 500);
    },
    show_improve_answer() {
      this.show_improve_modal = true;
    },
    collapse_improve_answer() {
      this.show_improve_modal = false;
    },
    show_regenerating_answer() {
      this.show_regenerating_modal = true;
    },
    collapse_regenarting_answer() {
      this.show_regenerating_modal = false;
    },
    async improve_answer() {
      const self = this;
      self.regeneration_error_message = null;
      self.regeneration_error = false;
      this.collapse_improve_answer();
      this.show_regenerating_answer();
      try {
        const response = await gqlMutation(IMPROVE_ANSWER, {uid: this.answer.uid, text: btoa(encodeURIComponent(this.improve_text).replace(/%([0-9A-F]{2})/gi, (_, p1) => String.fromCharCode(parseInt(p1, 16))))});
        const payload = response.body.data.improve_answer;
        if (payload.ok) {
          self.$emit("trigger-fetch-answers");
          this.collapse_regenarting_answer();
        } else {
          this.collapse_regenarting_answer();
          self.regeneration_error_message = payload.msg;
          self.regeneration_error = true;
        }
      } catch (error) {
        this.collapse_regenarting_answer();
        self.regeneration_error_message = error.statusText + " (" + error.status + ")";
        self.regeneration_error = true;
      }
    },
    async vote_for_best_answer() {
      const self = this;
      await gqlMutation(REVIEW_ENSURE_ALL_GAMES, {uid: this.$store.state.selected_review_uid});
      for (let i = 0; i < this.game_set.length; i++) {
        const game = this.game_set[i];
        const uid = this.answer.uid.toString();
        if ((game.answer1.uid === uid) || (game.answer2.uid === uid)) {
          await gqlMutation(UPDATE_GAME, {id: game.uid, best_answer_id: uid, best_button_pushed: true});
        }
      }
      self.$emit("trigger-fetch-review");
    }
  }
};
</script>

<style lang="scss" scoped>
.is-best_answer {
  background-color: rgba(65, 255, 128, 0.507);
}
</style>
  
